import {PromotionDetail} from "../../domain/dtos/promotion-detail";
import {PromotionDetailItemMapper} from "./promotion-detail-item.mapper";

export class PromotionDetailMapper {
    static deserialize(param: Record<string,any>): PromotionDetail {

        return {
            details: param.items.map(PromotionDetailItemMapper.deserialize),
            code: param.code,
            name: param.name,
            description: param.description,
            image: param.image,
            discountedPrice: param.promoPrice,
            price: param.noPromoPrice,
            discount: param.discount,
        }; 
    }
}
